import { fetchHelper } from "../utils"

export const getVideoProgresses = async () => {
    return fetchHelper({
        url: 'videoprogresses',
        method: 'GET',
    }) as Promise<any[]>
}

export const postVideoProgress = async (body: any) => {
    return fetchHelper({
        url: 'videoprogresses',
        method: 'POST',
        body
    }) as Promise<any>
}